<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toolbar from './components/layout/Toolbar.vue'
import { onMounted, ref, watchEffect } from 'vue'
import { ModalsContainer } from 'vue-final-modal'
import WhatNow from './components/common/WhatNow.vue'
import { storeToRefs } from 'pinia'
import LanguageSwitcher from './components/i18n/LanguageSwitcher.vue'
import router from './router'
import { useI18n } from 'vue-i18n';
import { useEnvironmentStore } from '@/stores/environmentStore'

const env = useEnvironmentStore()
const { contextId } = storeToRefs(env)
const appTitle = import.meta.env.VITE_APP_TITLE
const isOnboarding = ref(false)
const {t}  = useI18n();

onMounted(() => {
  isOnboarding.value = router.currentRoute.value.fullPath == '/onboarding'
})

watchEffect(() => {
  if (router.currentRoute.value.fullPath == '/onboarding') {
    isOnboarding.value = true
  } else {
    isOnboarding.value = false
  }
})

</script>
<template>
  <div class="wrapper" :class="{ onboarding: isOnboarding }">
    <header>
      <Toolbar
        v-if="
          !($route.fullPath == '/login') &&
          !($route.fullPath == '/new-user') &&
          !$route.params.campaignCode &&
          !isOnboarding
        "
      />
      <div v-else class="language">
        <LanguageSwitcher></LanguageSwitcher>
      </div>
    </header>
    <main>
      <RouterView />
      <ModalsContainer />
    </main>
    <footer v-if="!isOnboarding">
      <div class="actions">
        <button style=" cursor: pointer" class="ok" @click="$router.push({name: 'home'})" v-if="!($route.fullPath == '/')
          && !($route.fullPath == '/login')
          && !($route.fullPath == '/new-user')
          && !($route.params.campaignCode)">
          <font-awesome-icon :icon="['fas', 'arrow-left-long']" size="lg" style="color: #dedede"></font-awesome-icon>&nbsp;{{ $t('common.home') }}
        </button>
        <WhatNow
          :context-id="contextId"
          v-if="
            !($route.fullPath == '/login') &&
            !($route.fullPath == '/new-user') &&
            !$route.params.campaignCode
          "
        ></WhatNow>
      </div>
      <div class="copyright">
        <span
          >{{ appTitle }} &#169; <a href="https://www.hvana.no" target="new">Hva N&aring;</a>
          {{ new Date().getUTCFullYear() }}</span
        >
      </div>
    </footer>
  </div>
</template>

<style scoped>
.language {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.wrapper.onboarding {
  background-color: black;
}

.copyright {
  text-align: center;
  font-size: 0.8rem;
}

.copyright a,
.copyright a:visited {
  color: #00ffc8;
}
</style>
<style>
#app {
  background-color: black;
}
</style>
